import { render, staticRenderFns } from "./AlertPushModal.vue?vue&type=template&id=78d2a3d6&"
import script from "./AlertPushModal.vue?vue&type=script&lang=js&"
export * from "./AlertPushModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports